import React from 'react';
import { Tooltip } from '~/components/ui/Tooltip';

interface InspectDeploymentButtonProps {
  adminUrl: string | null;
  variant?: 'icon' | 'full';
}

export const InspectDeploymentButton = ({ adminUrl, variant = 'full' }: InspectDeploymentButtonProps) => {
  if (!adminUrl) {
    return null;
  }

  if (variant === 'icon') {
    return (
      <Tooltip content="Inspect Deployment">
        <a
          href={adminUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 text-[#e7e7e7]/70 hover:text-white bg-white/5
            hover:bg-white/10 rounded-md transition-colors"
        >
          <div className="i-ph:arrow-square-out w-4 h-4" />
        </a>
      </Tooltip>
    );
  }

  return (
    <a
      href={adminUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="w-full px-4 py-2.5 bg-white/5 border border-white/10 rounded-lg 
        text-[#e7e7e7] text-sm font-medium hover:bg-white/10 transition-colors
        flex items-center justify-center gap-2"
    >
      <span>Inspect Deployment</span>
      <div
        className="i-ph:arrow-square-out w-3.5 h-3.5 text-[#e7e7e7]/70 
          group-hover:text-white transition-colors flex-shrink-0"
      />
    </a>
  );
};
